@if (institutionId > 0) {
  <div id="submodule-sales" class="cw-module-card">
    <!-- Header -->
    <div class="cw-flex-row">
      <!-- Modul-Titel >
      <h2>{{ 'MODULES.INSTITUTIONS.SALES.SALES' | translate }}</h2-->
    </div>
    <div [ngClass]="loading ? 'icon-spinner icon-spin' : ''"></div>
    @if (data && !loading) {
      <form>
        <!-- Content -->
        <!--<div class="cw-submodules">
        <div class="cw-submodule">
          <h3>{{ 'MODULES.INSTITUTIONS.SALES.ANNUALSALES' | translate }}</h3>
          <div class="cw-horizontalline"></div>
          <phscw-input-text [editMode]="editMode" label="{{ 'MODULES.INSTITUTIONS.SALES.TURNOVER1' | translate }}" name="sales_year_current" inputId="sales_year_current" [(ngModel)]="data.yearCurrent"></phscw-input-text>
          <phscw-input-text [editMode]="editMode" label="{{ 'MODULES.INSTITUTIONS.SALES.TURNOVER2' | translate }}" name="sales_year_pre" inputId="sales_year_pre" [(ngModel)]="data.yearLast"></phscw-input-text>
          <phscw-input-text [editMode]="editMode" label="{{ 'MODULES.INSTITUTIONS.SALES.TURNOVER3' | translate }}" name="sales_year_pre_pre" inputId="sales_year_pre_pre" [(ngModel)]="data.yearLastLast"></phscw-input-text>
        </div>
      </div>-->
      @if (shownCharts.includes('products-sales')) {
        <phscw-generic-chart
          chartKey="products-sales"
          chartLocation="institutions"
          [backendOptionsOverride]="backendOptions">
        </phscw-generic-chart>
      }
      @if (shownCharts.includes('sales-per-product')) {
        <phscw-chart-sales-per-product
          chartLocation="institutions"
          [backendOptions]="backendOptions"
          >
        </phscw-chart-sales-per-product>
      }
      @if (shownCharts.includes('sales-per-month')) {
        <phscw-chart-sales-per-month
          chartLocation="institutions"
          [backendOptions]="backendOptions"
          >
        </phscw-chart-sales-per-month>
      }
    </form>
  }
</div>
}
